import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
    import type { ChangedFields, Employee } from '@/types';
    import EmployeeChangesGroup from '../EmployeeChangesGroup.vue';
    import { useI18n } from 'vue-i18n';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EmploymentTab',
  props: {
    employee: {},
    data: {},
    personalData: {},
    oldEmployment: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

    const alert = computed(() => {
        if (props.employee.employment_type != props.personalData?.old?.employment_type?.value) {
            return t('employee.changes.employment');
        }
    });

    const days = [
        'time_monday',
        'time_tuesday',
        'time_wednesday',
        'time_thursday',
        'time_friday',
        'time_saturday',
        'time_sunday',
    ];

    const values = computed(() => {
        if (
            props.employee.employment_type === 'App\\Models\\Salary\\CustomerSalariedEmployee' ||
            props.employee.employment_type === 'App\\Models\\Salary\\CustomerCEOEmployee'
        ) {
            return [
                ...days.map((day) => ({
                    name: day,
                    group: 'newEmployment',
                    key: 'employment',
                    oldValue: props.data?.old?.[day]?.value ?? 'no_change',
                })),
                {
                    name: 'salary',
                    group: 'newEmployment',
                    key: 'employment',
                },
                {
                    name: 'fixed_add_ons_monthly',
                    group: 'newEmployment',
                    key: 'employment',
                    oldValue: props.data?.old?.fixed_add_ons_monthly?.value ?? 'no_change',
                },
                ...(props.employee.employment?.has_free_car
                    ? [
                          {
                              name: 'has_free_car',
                              group: 'newEmployment',
                              key: 'employment',
                              translation: t('employee.employment.has_free_car'),
                              oldValue: props.data?.old?.has_free_car?.value
                                  ? t('forms.yes')
                                  : t('forms.no'),
                              realValue: props.employee.employment?.has_free_car
                                  ? t('forms.yes')
                                  : t('forms.no'),
                          },
                          {
                              name: 'free_car_monthly',
                              group: 'newEmployment',
                              key: 'employment',
                          },
                          {
                              name: 'free_car_filename',
                              group: 'newEmployment',
                              key: 'employment',
                          },
                          {
                              name: 'free_car_file_description',
                              group: 'newEmployment',
                              key: 'employment',
                          },
                      ]
                    : []),
                ...(props.employee.employment?.has_free_phone
                    ? [
                          {
                              name: 'has_free_phone',
                              group: 'newEmployment',
                              key: 'employment',
                              translation: t('employee.employment.has_free_phone'),
                              oldValue: props.data?.old?.has_free_phone?.value
                                  ? t('forms.yes')
                                  : t('forms.no'),
                              realValue: props.employee.employment?.has_free_phone
                                  ? t('forms.yes')
                                  : t('forms.no'),
                          },
                      ]
                    : []),
                ...(props.employee.employment?.has_health_insurance
                    ? [
                          {
                              name: 'has_health_insurance',
                              group: 'newEmployment',
                              key: 'employment',
                              translation: t('employee.employment.has_health_insurance'),
                              oldValue: props.data?.old?.has_health_insurance?.value
                                  ? t('forms.yes')
                                  : t('forms.no'),
                              realValue: props.employee.employment?.has_health_insurance
                                  ? t('forms.yes')
                                  : t('forms.no'),
                          },
                      ]
                    : []),
            ];
        } else if (
            props.employee.employment_type ===
            'App\\Models\\Salary\\CustomerBHonorariumReceiverEmployee'
        ) {
            return [];
        } else {
            return [
                {
                    name: 'hourly_rate',
                    group: 'newEmployment',
                    key: 'employment',
                },
            ];
        }
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(EmployeeChangesGroup, {
    data: _ctx.data,
    values: values.value,
    employee: _ctx.employee,
    alert: alert.value
  }, null, 8, ["data", "values", "employee", "alert"]))
}
}

})